import * as FileSaver from 'file-saver';
import { AgentMetricMetColor, ConstApprovalStatus, Numbers } from '../../utils/typeConstants';

export const exportExcel = (data:any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'payoutData');
    });
};

export const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};

export const colorCode = (metricAttained: number) => {
    if (metricAttained === Numbers.ONE) return AgentMetricMetColor.METRIC_MET1;
    else if (metricAttained === Numbers.TWO) return AgentMetricMetColor.METRIC_MET2;
    else if (metricAttained === Numbers.THREE) return AgentMetricMetColor.METRIC_MET3;
    else if (metricAttained === Numbers.FOUR) return AgentMetricMetColor.METRIC_MET4;
    else if (metricAttained === Numbers.FIVE) return AgentMetricMetColor.METRIC_MET5;
    else return AgentMetricMetColor.METRIC_MET5;
};
export const statusIndicatorIcon = (rowData: any,approvalGrid?:string) => {
    let icon = null;
    if (approvalGrid === 'TeamLeadPayout') {
        switch (rowData.approval_status_id) {
            case ConstApprovalStatus.DISPUTED:
            case ConstApprovalStatus.DISQUALIFIED:
                icon = 'disputed';
                break;
            case ConstApprovalStatus.OPEN:
            case ConstApprovalStatus.ASSOCIATE_APPROVED:
                icon = '';
                break;
            default:
                icon = 'approved';
                break;
        }
    }
    else if (approvalGrid === 'TeamPayout') {
        switch (rowData.approval_status_id) {
            case ConstApprovalStatus.DISPUTED:
            case ConstApprovalStatus.DISQUALIFIED:
                icon = 'disputed';;
                break;
            case ConstApprovalStatus.TEAM_LEAD_APPROVED:
                icon = 'approved';
                break;
            default:
                icon = '';
                break;
        }
    }
    else if (approvalGrid === 'AssociatePayout') {
        switch (rowData.approval_status_id) {
            case ConstApprovalStatus.DISPUTED:
            case ConstApprovalStatus.DISQUALIFIED:
                icon = 'disputed';
                break;
            case ConstApprovalStatus.ASSOCIATE_APPROVED:
                icon = 'approved';
                break;
            default:
                icon = '';
                break;
        }
    }
    return icon;
};